// ============================================================================
// SPANISH TRANSLATIONS - JESUS IS NOT
// ============================================================================
// Aclaraciones sobre quién es Jesús (y quién no es)

export const jesusIsNot = [
  {
    category: "amor",
    text: "Jesús no es racista - Él ama a todos por igual sin importar su origen",
    reference: "Juan 4:9 - La mujer samaritana se sorprende de que Jesús le hable",
    context: "Jesús rompe las barreras culturales y raciales de su época"
  },
  {
    category: "exclusión",
    text: "Jesús no es excluyente - Él acoge a todos, especialmente a los marginados",
    reference: "Mateo 9:10-13 - Jesús come con publicanos y pecadores",
    context: "Jesús busca a los perdidos y rechazados de la sociedad"
  },
  {
    category: "juicio",
    text: "Jesús no es condenador - Él vino a salvar, no a condenar",
    reference: "Juan 3:17 - Dios no envió a su Hijo para condenar al mundo",
    context: "La misión de Jesús es la salvación y la restauración"
  },
  {
    category: "violencia",
    text: "Jesús no es violento - Él enseña el amor a los enemigos",
    reference: "Mateo 5:44 - Amad a vuestros enemigos",
    context: "Jesús revoluciona el concepto de justicia con el amor radical"
  },
  {
    category: "riqueza",
    text: "Jesús no es materialista - Él advierte contra el amor al dinero",
    reference: "Mateo 6:24 - No podéis servir a Dios y a las riquezas",
    context: "Jesús prioriza los tesoros celestiales sobre los terrenales"
  },
  {
    category: "orgullo",
    text: "Jesús no es orgulloso - Él se humilla y sirve",
    reference: "Juan 13:5 - Jesús lava los pies de sus discípulos",
    context: "Jesús muestra que la grandeza está en el servicio humilde"
  },
  {
    category: "legalismo",
    text: "Jesús no es legalista - Él pone la misericordia por encima del ritual",
    reference: "Mateo 12:7 - Misericordia quiero, y no sacrificio",
    context: "Jesús critica el legalismo que olvida el corazón de la ley"
  },
  {
    category: "género",
    text: "Jesús no es sexista - Él honra y valora a las mujeres",
    reference: "Juan 4:27 - Los discípulos se sorprenden de que hable con una mujer",
    context: "Jesús desafía las normas patriarcales de su cultura"
  },
  {
    category: "poder",
    text: "Jesús no es tirano - Él lidera con amor y ejemplo",
    reference: "Mateo 20:28 - El Hijo del Hombre vino para servir",
    context: "Jesús redefine el liderazgo como servicio sacrificial"
  },
  {
    category: "venganza",
    text: "Jesús no es vengativo - Él perdona y restaura",
    reference: "Lucas 23:34 - Padre, perdónalos, porque no saben lo que hacen",
    context: "Jesús practica el perdón radical incluso en la cruz"
  },
  {
    category: "indiferencia",
    text: "Jesús no es indiferente - Él se conmueve ante el sufrimiento",
    reference: "Mateo 9:36 - Tuvo compasión de las multitudes",
    context: "Jesús muestra empatía profunda por los que sufren"
  },
  {
    category: "élite",
    text: "Jesús no es elitista - Él se rodea de gente común",
    reference: "Marcos 1:16-20 - Jesús llama a pescadores como discípulos",
    context: "Jesús elige a personas ordinarias para su misión extraordinaria"
  },
  {
    category: "hipocresía",
    text: "Jesús no es hipócrita - Él vive lo que enseña",
    reference: "Juan 8:46 - ¿Quién de vosotros me redarguye de pecado?",
    context: "Jesús desafía a encontrar contradicción entre sus palabras y acciones"
  },
  {
    category: "rigidez",
    text: "Jesús no es rígido - Él adapta su enseñanza a cada persona",
    reference: "Juan 3 - Jesús habla diferente a Nicodemo que a la samaritana",
    context: "Jesús personaliza su mensaje según las necesidades de cada uno"
  },
  {
    category: "tradición",
    text: "Jesús no es tradicionalista ciego - Él cuestiona tradiciones que oprimen",
    reference: "Marcos 7:13 - Invalidando la palabra de Dios con vuestra tradición",
    context: "Jesús prioriza el espíritu de la ley sobre las tradiciones humanas"
  },
  {
    category: "nacionalismo",
    text: "Jesús no es nacionalista - Su reino trasciende fronteras",
    reference: "Mateo 28:19 - Id y haced discípulos a todas las naciones",
    context: "La misión de Jesús es universal, no limitada a un solo pueblo"
  },
  {
    category: "división",
    text: "Jesús no es divisivo - Él ora por la unidad de los creyentes",
    reference: "Juan 17:21 - Que todos sean uno",
    context: "Celebremos nuestras diversidades en lugar de crear guerras de palabras"
  },
  {
    category: "verdad",
    text: "Jesús no es mentiroso - Él denuncia la mentira y la manipulación",
    reference: "Juan 8:44 - El diablo es padre de mentira",
    context: "Jesús expone las mentiras y manipulaciones que dañan las almas"
  },
  {
    category: "generosidad",
    text: "Jesús no es avaro - Su generosidad supera ampliamente el diezmo",
    reference: "Lucas 21:3 - Esta viuda pobre echó más que todos",
    context: "La generosidad de Jesús es más fuerte que la obligación del diezmo"
  },
  {
    category: "justicia",
    text: "Jesús no es cómplice del silencio - Él protege con una justicia sana",
    reference: "Mateo 18:6 - El que haga tropezar a uno de estos pequeños",
    context: "El silencio que encubre faltas sin proteger a otros no es la sabiduría de Jesús"
  }
];

export default jesusIsNot;
